module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '68pzrlio',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
